import { Injectable } from '@angular/core';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as SpaycialIntegrationActions from './spaycial-integration-actions';
import { SpaycialIntegrationApiService } from '@app/+spaycial-integration/api/spaycial-integration-api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';

@Injectable()
export class SpaycialIntegrationEffects {

  public loadStatus$ = createEffect(() => this.actions$.pipe(
    ofType(SpaycialIntegrationActions.loadStatus),
    switchMap(() => this.service.isConnected().pipe(
      map(({ active, scanUser }) => SpaycialIntegrationActions.loadStatusSuccess({ active, scanUser })),
      catchError((error: HttpErrorResponse) => of(SpaycialIntegrationActions.loadStatusFailure({ error }))),
    )),
  ));

  public connect$ = createEffect(() => this.actions$.pipe(
    ofType(SpaycialIntegrationActions.connect),
    switchMap(({ callbackUrl }) => this.service.connect(callbackUrl).pipe(
      map((redirectUrl) => SpaycialIntegrationActions.connectSuccess({ redirectUrl })),
      catchError((error: HttpErrorResponse) => of(SpaycialIntegrationActions.connectFailure({ error }))),
    )),
  ));

  public disconnect$ = createEffect(() => this.actions$.pipe(
    ofType(SpaycialIntegrationActions.disconnect),
    switchMap(() => this.service.disconnect().pipe(
      map(() => SpaycialIntegrationActions.disconnectSuccess()),
      catchError((error: HttpErrorResponse) => of(SpaycialIntegrationActions.disconnectFailure({ error }))),
    )),
  ));

  public disconnectSuccess$ = createEffect(() => this.actions$.pipe(
    ofType(SpaycialIntegrationActions.disconnectSuccess),
    map(SpaycialIntegrationActions.loadStatus),
  ));

  public loadConnections$ = createEffect(() => this.actions$.pipe(
    ofType(SpaycialIntegrationActions.loadConnections),
    switchMap(({ callbackUrl }) => this.service.getConnections(callbackUrl).pipe(
      map((redirectUrl) => SpaycialIntegrationActions.loadConnectionsSuccess({ redirectUrl })),
      catchError((error: HttpErrorResponse) => of(SpaycialIntegrationActions.loadConnectionsFailure({ error }))),
    )),
  ));

  public loadActivities$ = createEffect(() => this.actions$.pipe(
    ofType(SpaycialIntegrationActions.loadActivities),
    switchMap(({ callbackUrl }) => this.service.getActivities(callbackUrl).pipe(
      map((redirectUrl) => SpaycialIntegrationActions.loadActivitiesSuccess({ redirectUrl })),
      catchError((error: HttpErrorResponse) => of(SpaycialIntegrationActions.loadActivitiesFailure({ error }))),
    )),
  ));

  public loadProfile$ = createEffect(() => this.actions$.pipe(
    ofType(SpaycialIntegrationActions.loadProfile),
    switchMap(() => this.service.getProfile().pipe(
      map((redirectUrl) => SpaycialIntegrationActions.loadProfileSuccess({ redirectUrl })),
      catchError((error: HttpErrorResponse) => of(SpaycialIntegrationActions.loadProfileFailure({ error }))),
    )),
  ));

  public loadOffers$ = createEffect(() => this.actions$.pipe(
    ofType(SpaycialIntegrationActions.loadOffers),
    switchMap(() => this.service.getOffers().pipe(
      map((redirectUrl) => SpaycialIntegrationActions.loadOffersSuccess({ redirectUrl })),
      catchError((error: HttpErrorResponse) => of(SpaycialIntegrationActions.loadOffersFailure({ error }))),
    )),
  ));

  constructor(private actions$: Actions, private service: SpaycialIntegrationApiService) {}

}
